import { getBridgeRoot } from '../../../files/cwd/bridge-root.js';
import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { scheduleSymbolIndexWarmup } from '../scheduler/symbol-index-scheduler.js';
import { symbolIndexIsPopulated } from '../sqlite/symbol-index-sqlite.js';
import { buildSymbolIndexAsync } from './build-symbol-index.js';

export async function ensureSymbolIndexAsync(parentPath: string): Promise<{ fromCache: boolean; fileCount: number; tagCount: number }> {
  const resolved = normalizeResolvedPath(parentPath);
  if (symbolIndexIsPopulated(resolved)) {
    return { fromCache: true, fileCount: 0, tagCount: 0 };
  }

  const bridgeRoot = normalizeResolvedPath(getBridgeRoot());
  if (resolved !== bridgeRoot && !symbolIndexIsPopulated(bridgeRoot)) {
    scheduleSymbolIndexWarmup(bridgeRoot);
  }

  scheduleSymbolIndexWarmup(resolved);
  const built = await buildSymbolIndexAsync(resolved);
  return { fromCache: false, ...built };
}
